import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { UserData } from '../../dto/user-data';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchService } from '@pcplus/infrastructure';
import { NgIf, NgClass } from '@angular/common';
import { MatFabButton } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'pcp-users-container',
    templateUrl: './users-container.component.html',
    styleUrls: ['./users-container.component.scss'],
    imports: [NgIf, MatFabButton, NgClass, ExtendedModule, MatIcon, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatCheckbox, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class UsersContainerComponent implements OnInit, OnDestroy {
  constructor(
    public search: SearchService,
    private dir: Directionality
  ) {
    this.isRtl = dir.value === 'rtl';
  }

  isRtl: boolean;
  highlightedUser: UserData | null = null;
  private searchValue: string | null = null;
  onDestroy$ = new Subject<void>();
  @Input() users: UserData[] | null = null;
  private _value: string[] | string | null = null;
  editMode = false;
  displayedUsers: UserData[] = [];
  @Input() canEdit = true;
  @Input() multiSelect = true;
  @Input() set value(value: string[] | string | null) {
    this._value = value;
    if (this.users) {
      this.refreshDisplayedUsers();
    }
  }
  get value() {
    return this._value;
  }
  @Output()
  valueChange = new EventEmitter<string[] | string | null>();

  ngOnInit() {
    this.search
      .registerSearchClient('users-container')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((srch) => {
        this.searchValue = srch;
        this.refreshDisplayedUsers();
      });
    this.refreshDisplayedUsers();
  }

  applySelectionChange(id: string, isSelected: boolean) {
    if (!this.users) {
      return;
    }
    if (!this.value && this.multiSelect) {
      this.value = new Array<string>();
    }
    if (isSelected) {
      if (Array.isArray(this.value)) {
        this.value.push(id);
        this.value = this.value.slice();
      } else {
        this.value = id;
      }
    } else {
      if (Array.isArray(this.value)) {
        this.value = this.value.filter((v) => v !== id);
      } else {
        this.value = null;
      }
    }
    this.valueChange.emit(this.value);
  }

  isSelected(user: UserData) {
    if (!this.value) {
      return false;
    }
    if (Array.isArray(this.value)) {
      return this.value.includes(user.id);
    } else {
      return user.id === this.value;
    }
  }

  refreshDisplayedUsers() {
    if (this.users) {
      if (!this.value) {
        this.value = [];
      }
      const users = this.editMode
        ? this.users.slice()
        : this.users.filter((u) => this.value!.includes(u.id));
      if (!this.searchValue) {
        this.displayedUsers = users;
      } else {
        this.displayedUsers = users.filter((u) => {
          const loweredSearch = this.searchValue!.toLocaleLowerCase();
          return (
            u.id.toLocaleLowerCase().includes(loweredSearch) ||
            u.firstName.toLocaleLowerCase().includes(loweredSearch) ||
            u.lastName.toLocaleLowerCase().includes(loweredSearch)
          );
        });
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
